<template>
  <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.3018,10.4336l0.0908,0.3677l0.3789,0.0117
      c0.4255,0.0135,0.8248,0.1093,1.2029,0.2466c1.3015-0.1574,2.3879-1.0129,2.8618-2.1874
      c-0.2594,0.0605-0.5298,0.0925-0.8076,0.0925c-1.9585,0-3.5463-1.5878-3.5463-3.5462c0-0.4689,0.0909-0.9164,0.256-1.326
      c-1.3716,0.3194-2.4368,1.4349-2.6837,2.8329C16.1385,7.7931,16.9482,9.0055,17.3018,10.4336z"/>
    <path d="M10.9998,6.0003c2.7609,0,5.1527,1.8724,5.8164,4.5533l0.182,0.7352l0.7571,0.024
      c1.8193,0.0576,3.2445,1.5236,3.2445,3.3375c0,1.8472-1.5028,3.35-3.35,3.35h-12.4c-1.2406,0-2.25-1.0093-2.25-2.2499
      c0-0.921,0.5547-1.7391,1.4131-2.0842l0.6991-0.2811l-0.0774-0.7496c-0.0234-0.2261-0.0348-0.4339-0.0348-0.6351
      C4.9998,8.6919,7.6914,6.0003,10.9998,6.0003 M10.9998,5.0003c-3.866,0-7,3.1331-7,7.0001c0,0.2499,0.015,0.4958,0.04,0.738
      c-1.194,0.48-2.04,1.6449-2.04,3.012c0,1.794,1.4551,3.2499,3.25,3.2499h12.4c2.403,0,4.35-1.9479,4.35-4.35
      c0-2.3559-1.875-4.263-4.2129-4.337C17.0317,7.2634,14.2838,5.0003,10.9998,5.0003L10.9998,5.0003z"/>
  </g>
</template>

<script>
export default {
  name: 'PartlyCloudyNight'
}
</script>